module.exports = __webpack_public_path__ + "static/media/loader.917b3a32.gif";